/* eslint-disable import/no-extraneous-dependencies */

import { combineReducers } from 'redux';
import bookStoreReducer from './bookStore/bookStoreReducer';
import statusReducer from './bookStore/status/statusReducer';

const rootReducer = combineReducers({
  books: bookStoreReducer,
  status: statusReducer,
});

export default rootReducer;
